export default __webpack_public_path__ + "navigation-examples-route-deserialize-960-56abf3eac3636350597ea5e890d75e23.webp";